module.exports = __webpack_public_path__ + "fe5f6becde8352990f475108e13d75a3.png";